import { motion } from "framer-motion";
import { PencilRuler, ClipboardList, Hammer, KeyRound } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const stepIcons = [PencilRuler, ClipboardList, Hammer, KeyRound];

export const Process = () => {
  const { t } = useLanguage();

  return (
    <section id="process" className="py-24 lg:py-32 bg-[#2A211D]" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-[#D4AF37] tracking-[0.4em] uppercase text-sm mb-4">{t.process.eyebrow}</p>
          <h2 className="font-heading text-4xl sm:text-5xl text-[#FDFBF7] max-w-2xl" data-testid="process-heading">
            {t.process.heading}
          </h2>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {t.process.steps.map((s, i) => {
            const Icon = stepIcons[i];
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.12 }}
                className="relative border-t border-[#D4AF37]/30 pt-8"
                data-testid={`process-step-${i + 1}`}
              >
                <span className="font-heading text-6xl text-[#D4AF37]/20 absolute -top-2 right-0">0{i + 1}</span>
                <Icon className="h-8 w-8 text-[#D4AF37]" />
                <h3 className="mt-5 font-heading text-2xl text-[#FDFBF7]">{s.title}</h3>
                <p className="mt-3 text-[#B8A99A] text-sm leading-relaxed">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
